import '../App.css';
import Canvas from './Canvas';
import React, {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useLocation} from 'react-router-dom';
import { downloadExcel } from '../utils/excelUtils';

const API_KEY = 'TWIGFARM_API_GATEWAY_WEBSOCKET'; // dev & prod the same

// const MODE = 'PROD';
const MODE = process.env.REACT_APP_RELEASE_MODE;

const webSocketUrl =
    MODE === 'DEV'
        ? 'wss://rf6mz048k6.execute-api.ap-northeast-2.amazonaws.com/dev'
        : 'wss://pb27uyr3dk.execute-api.ap-northeast-2.amazonaws.com/ws1';

const API_BASEURL =
    MODE === 'DEV'
        ? 'https://seqtlevcy8.execute-api.ap-northeast-2.amazonaws.com/dev'
        : 'https://x7ztt0l1yg.execute-api.ap-northeast-2.amazonaws.com/v1';

const BUCKET_NAME = MODE === 'DEV' ? 'kidari.api.private' : 'ai-tms';
const KIDARI_PROD_API_KEY = 'KIDARI_BE_DEVTEAM_PROD';

function StepsSeparated() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [images, setImages] = useState([]);
    const [parsedJson, setParsedJson] = useState([]);
    const [parsedJsonTemp, setParsedJsonTemp] = useState([]);
    const [translatedJson, setTranslatedJson] = useState([]);
    const [translationId, setTranslationId] = useState(queryParams.get('translation_id'));
    const [apiKeyInput, setApiKeyInput] = useState(KIDARI_PROD_API_KEY);
    const [loading, setLoading] = useState(false);
    const [imageWidthHeightMap, setImageWidthHeightMap] = useState({});

    const wsRef = useRef(null);

    useEffect(async () => {
        await requestSourceTexts();
        await requestImageUrls(translationId);
        const ws = new WebSocket(webSocketUrl);
        wsRef.current = ws;

        ws.onopen = () => {
            handleWebsocketOpen();
        };
        ws.onmessage = async (event) => {
            handleWebsocketMessage(event);
        };
        ws.onclose = () => {
            handleWebsocketClose();
        };

        return () => {
            // Close WebSocket connection on unmount
            if (ws) {
                ws.close();
            }
        };
    }, []);

    const handleWebsocketOpen = () => {
        console.log('Websocket connected');
        setLoading(false);
    };
    const handleWebsocketMessage = async (event) => {
        const response = JSON.parse(event.data);
        if (response.type === 'heartbeat') {
            return;
        }

        console.log('response.state: ', response.state);
        if (response.state === 'parsed') {
            loadImageParsedJson(response.data);
        } else if (response.state === 'translated') {
            setTranslatedJson(response.data);
        }

        await requestImageUrls(response.translation_id);
        setLoading(false);
    };

    const loadImageParsedJson = (parsedData) => {
        console.log('loadImageParsedJson: ', parsedData);
        const localWidthHeightMap = {};
        for (const bubble of parsedData) {
            localWidthHeightMap[bubble.image] = {
                width: bubble.width,
                height: bubble.height,
            };
        }
        setImageWidthHeightMap(localWidthHeightMap);
        setParsedJson(parsedData);

    };

    const handleDownload = async () => {
        if (!parsedJson || parsedJson.length === 0) {
            alert('다운로드할 데이터가 없습니다.');
            return;
        }
        try {
            // 이미지 URL을 image state의 값으로 변환
            const dataWithFullUrls = parsedJson.map((item, index) => ({
                ...item,
                image: images[index]?.url || '' // image state의 해당 인덱스의 url 사용
            }));
            
            console.log('parsedJson: ', dataWithFullUrls);
            await downloadExcel(dataWithFullUrls);
        } catch (error) {
            console.error('Error downloading Excel:', error);
            alert('엑셀 다운로드 중 오류가 발생했습니다.');
        }
    };

    const connect = () => {
        let ws = wsRef.current;

        if (ws.readyState !== WebSocket.OPEN) {
            console.log('Attempting to reconnect...');
            ws.close();
            wsRef.current = new WebSocket(webSocketUrl);
            ws = wsRef.current;
        }
        ws.onopen = () => {
            handleWebsocketOpen();
        };
        ws.onmessage = async (event) => {
            handleWebsocketMessage(event);
        };
        ws.onclose = () => {
            handleWebsocketClose();
        };
    };

    const handleWebsocketClose = () => {
        console.log('WebSocket disconnected');
        // Attempt to reconnect after a delay
        setTimeout(() => {
            console.log('Reconnecting to WebSocket server...');
            connect();
        }, 5000);
    };

    const handleTranslationIdChange = (event) => {
        setTranslationId(event.target.value);
    };

    const requestImageUrls = async (translationId) => {
        const recropS3Key = `ai_jp/recropped/${translationId}/`;
        const response = await axios.get(`${API_BASEURL}/image-urls?s3_bucket=${BUCKET_NAME}&s3_key=${recropS3Key}`, {
            headers: {
                'x-api-key': API_KEY,
            },
        });
        console.log('response: ', response);
        setImages(response.data.image_urls);
    };

    const requestStep2Translations = async (event) => {
        event.preventDefault();
        if (loading) {
            return;
        }
        const result = window.confirm(`번역을 요청하겠습니다. 진행하시겠습니까?`);
        if (!result) {
            return;
        }

        setLoading(!apiKeyInput);
        setTranslatedJson([]);
        const url = `${API_BASEURL}/step2-translations`;

        const headerData = {
            headers: {
                'content-type': 'application/json',
                'x-api-key': apiKeyInput || API_KEY,
            },
        };
        const cleansedParsedJson = [];
        for (const item of parsedJson) {
            if (item.isDeleted) {
                continue;
            }
            let data = JSON.parse(JSON.stringify(item))
            if(data.source_text){
                // data.ocr = data.source_text

            }
            if(data.ocrpe){
                // data.ocr = data.source_text
                // delete data.ocrpe
            }
            cleansedParsedJson.push(data);
        }
        const payload = {
            data: cleansedParsedJson,
            translation_id: translationId,
        };
        try {
            const result = await axios.post(url, payload, headerData);
            console.log('result: ', result);

            alert(`성공적으로 번역을 요청했습니다.\n\ntranslation_id: ${translationId}`);
            const ws = wsRef.current;
            ws.send(
                JSON.stringify({
                    method: 'registerTranslationId',
                    translationId,
                })
            );
        } catch (error) {
            setLoading(false);
            alert('번역 요청이 실패했습니다. 서버 로그를 확인해주세요.');
        }
    };

    const handleApiKeyInputChange = (event) => {
        setApiKeyInput(event.target.value);
    };

    const handleRefine = (index, value) => {
        const updatedParsedJson = [...parsedJson];
        const prevParsedJson = {...parsedJson[index]};
        prevParsedJson.ocrpe = value;
        updatedParsedJson[index] = prevParsedJson;
        setParsedJson(updatedParsedJson);
        setParsedJsonTemp(...updatedParsedJson);
    };

    const handleResize = (index, value) => {
        setParsedJson((prevParsedJson) => {
            if (prevParsedJson.length > index) {
                // console.log("1")
                // console.log(prevParsedJson[index].vertices)
                // console.log(value)
                // console.log("1")
                prevParsedJson[index].vertices = value;
            }
            return prevParsedJson;
        });
    };

    const handleClose = (index) => {
        console.log('index: ', index);
        const updatedParsedJson = [...parsedJson];
        const prevParsedJson = {...parsedJson[index]};
        prevParsedJson.isDeleted = true;
        updatedParsedJson[index] = prevParsedJson;
        setParsedJson(updatedParsedJson);

    };

    const handleRectangleCreate = (rectObject) => {
        const updatedParsedJson = [...parsedJson, {...rectObject}];
        setParsedJson(updatedParsedJson);
    };

    const handleResetButtonClick = async (event) => {
        event.preventDefault();
        const result = window.confirm(
            'OCR 결과물로 되돌립니다. 현재까지 작업하신 정제 내용은 사라집니다. 진행하시겠습니까?'
        );
        if (result) {
            await requestSourceTexts('ocr');
        }
    };

    const handleLoadButtonClick = async (event) => {
        event.preventDefault();
        const result = window.confirm(
            '저장된 결과물로 되돌립니다. 현재까지 작업하신 정제 내용은 사라집니다. 진행하시겠습니까?'
        );
        if (result) {
            await requestSourceTexts('latest');
        }
    };

    const requestSourceTexts = async (version) => {
        setLoading(true);
        const versionText = version ? `&version=${version}` : '';

        try {
            const response = await axios.get(`${API_BASEURL}/source-texts?translation_id=${translationId}${versionText}`, {
                headers: {
                    'x-api-key': API_KEY,
                },
            });
            console.log('response: ', response);

            loadImageParsedJson(response.data.data);
            let str = JSON.stringify(response.data.data)
            setParsedJsonTemp(JSON.parse(str));
        } catch (err) {
            alert('화면에 표시할 OCR 데이터가 존재하지 않습니다.');
        }

        setLoading(false);
    };

    const handleSaveButtonClick = async (event) => {
        event.preventDefault();
        setLoading(true);

        const headerData = {
            headers: {
                'content-type': 'application/json',
                'x-api-key': API_KEY,
            },
        };

        //새로 생긴 textarea 포커스를 주기 위한 프로퍼티 삭제
        for (let param in parsedJson) {
            if (parsedJson[param].focus) {
                delete parsedJson[param].focus
            }
        }

        // for (let param in parsedJson) {
        //     if (parsedJson[param].source_text) {
        //        console.log(parsedJson[param].source_text)
        //         parsedJson[param].ocrpe = parsedJson[param].source_text
        //     }
        // }


        let data = JSON.parse(JSON.stringify(parsedJson))
        const payload = {
            translation_id: translationId,
            data: data,
        };

        try {
            await axios.put(`${API_BASEURL}/source-texts`, payload, headerData);
            alert('저장되었습니다.');
        } catch (err) {
            console.error(err);
            alert('저장에 실패했습니다.');
        }
        setLoading(false);
    };
    if (!translationId) {
        return <h3>translation_id 가 유효하지 않습니다.</h3>;
    }

    return (
        <div className="main-container">
            <div className="button-container">
                <p>Translation ID: {translationId}</p>
                <div className="step1-buttons">
                    <button className="step1-button" onClick={handleResetButtonClick} disabled={loading}>
                        OCR 직후 상태로 되돌리기
                    </button>
                    <button className="step1-button" onClick={handleSaveButtonClick} disabled={loading}>
                        현재까지 작업내용 저장하기
                    </button>
                    <button className="step1-button" onClick={handleLoadButtonClick} disabled={loading}>
                        저장된 내용 불러오기
                    </button>
                    <button className="step1-button" onClick={handleDownload} disabled={loading}>
                        엑셀 다운로드
                    </button>
                </div>

                {parsedJson?.length > 0 && (
                    <div className="step2-form">
                        {/* <p className="api-key-explanation">
              API key를 입력하면 해당 API key와 연결되어있는 Callback URL로 결과물이 전달됩니다.
            </p> */}
                        <form onSubmit={requestStep2Translations}>
                            <p className="api-key-explanation">
                                API key를 입력하지 않으면 화면에 번역결과물이 표시됩니다. API key를 입력하면 해당 API key와 연결되어있는
                                Callback URL로 결과물이 전달됩니다.
                            </p>
                            <label htmlFor="api-key">API Key:</label>
                            <input
                                type="text"
                                id="api-key"
                                name="api-key"
                                disabled={loading || !translationId}
                                value={apiKeyInput}
                                onChange={handleApiKeyInputChange}
                            />

                            <button type="submit" disabled={loading || !translationId}>
                                {loading ? 'Loading...' : 'Step 2: 번역요청하기'}
                            </button>
                        </form>
                    </div>
                )}
            </div>

            <div className="canvas-container">
                <div className="canvas-images">
                    {images.map((image) => {
                        return <Canvas key={`${image.file}_image-only`} image={image} imageWidthHeightMap={imageWidthHeightMap}/>;
                    })}
                </div>
                <div className="canvas-images">
                    {images.map((image) => {
                        return (
                            <Canvas
                                key={`${image.file}_parsed`}
                                image={image}
                                parsedJson={parsedJson}
                                onChange={handleRefine}
                                onResize={handleResize}
                                onClose={handleClose}
                                onRectangleCreate={handleRectangleCreate}
                                imageWidthHeightMap={imageWidthHeightMap}
                            />
                        );
                    })}
                </div>
                {translatedJson?.length > 0 && (
                    <div className="canvas-images">
                        {images.map((image) => {
                            return (
                                <Canvas
                                    key={`${image.file}_translated`}
                                    image={image}
                                    translatedJson={translatedJson}
                                    imageWidthHeightMap={imageWidthHeightMap}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default StepsSeparated;
